import { Box, Input } from "@govlaunch/web";
import { debounce } from "lodash/fp";
import { useRouter } from "next/router";
import React, { DependencyList, EffectCallback, useCallback, useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import stripUndefined from "~/lib/utils/stripUndefined";

export default function CollectionsListingPageFilters() {
  const router = useRouter();
  const intl = useIntl();
  const inputRef = useRef<HTMLInputElement>();

  const [searchQuery, setSearchQuery] = useState(() => {
    return Array.isArray(router.query.query) ? router.query.query[0] : router.query.query || "";
  });

  const performSearch = useCallback(
    (searchQuery: string) => {
      router.push({
        pathname: router.pathname,
        query: stripUndefined({
          ...router.query,
          query: searchQuery,
        }),
      });
    },
    [router.query],
  );

  const performSearchWithDelay = useCallback(debounce(1000, performSearch), [performSearch]);

  useUpdateEffect(() => performSearchWithDelay(searchQuery), [searchQuery]);

  return (
    <Box bg={["none", "none", "blue.100"]} px={[0, 0, 10]} py={[0, 0, 3]}>
      <Input
        ref={inputRef}
        aria-label={intl.formatMessage({
          defaultMessage: "Search for collections",
          id: "EWy3CT",
        })}
        placeholder={intl.formatMessage({
          defaultMessage: "Search for collections",
          id: "EWy3CT",
        })}
        data-intercom-target="Search collections"
        size="md"
        value={searchQuery}
        onKeyDown={(event) => {
          if (event.key === "Enter" && inputRef.current && inputRef.current.value) {
            performSearch(inputRef.current.value);
          }
        }}
        onChange={(event) => {
          setSearchQuery(event.target.value);
        }}
      />
    </Box>
  );
}

function useUpdateEffect(effect: EffectCallback, dependencies: DependencyList = []) {
  const isInitialMount = useRef(true);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else {
      return effect();
    }
  }, dependencies);
}
